'use client';

import { Nav } from './nav';
import styles from './header.module.scss';
import { PlayButton } from '../../../ui/play-button/play-button';
import { liveBroadcast } from '../../../../libs/constants/live-broadcast';
import LogoSvg from '../../../ui/icons/logoSVG';
import { SectionPlaySearchBlind } from './section-play-search-blind/section-play-search-blind';
import clsx from 'clsx';
import { useAppSelector } from '../../../../store/hooks';
import { getBlindMode } from '../../../../store/slices/blind-mode.slices';

export const Header = () => {
  const { blindWrapClass } = useAppSelector(getBlindMode);
  const [live] = liveBroadcast;

  return (
    <header className={clsx(styles.header, { [styles.blindWrapClass]: blindWrapClass })}>
      <LogoSvg className={styles.logoSVG} />
      <Nav /> {/* Меню навигации по сайту */}
      <PlayButton
        text={'Прямой эфир'}
        track={live}
        className={styles.buttonDesk}
        radioBtn={true}
      />
      <SectionPlaySearchBlind live={live} />
    </header>
  );
};
